import {Modal, Row} from "antd";
import React from "react";
import {ModalCloseIco} from "../../../../../../modules/CustomIcons";

const MoreModal: React.FC<any> = (props) => {
    const onClose = () => {
        props.onClose((old_value) => false)
    }
    return (
            <>
                <Modal
                    open={props.visible}
                    footer={false}
                    closeIcon={<ModalCloseIco />}
                    centered
                    onCancel={onClose}
                    title={'Ətraflı'}
                    width={760}
                >
                    <table>
                        {
                            <>
                                <th>Ödəniş növü</th>
                                <tr></tr>
                                <th>Ödənişi alan</th>
                                <th>Bank rekvizitləri</th>
                                <th>Qaimə Məlumatları</th>
                            </>


                            // console.log(props.modalData)
                            // props.modalData?.map((row)=>{
                            //     return(
                            //         <>
                            //             <th>{row.label}</th>
                            //             <tr>{row.value}</tr>
                            //         </>
                            //
                            // )
                            // })
                        }

                    </table>
                </Modal>
            </>
        )
}

export default MoreModal